export default __webpack_public_path__ + "static/media/priyal.f4932c54.webp";